// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__sdWdU","tab":"ProcedureTabs_tab__2pvQA"};